import useBranches from "./useBranches";

const useFormules = () => {
  return useBranches().slice(0, 6);
};

export default useFormules;
